/**
 * Module definition for states module. The states module manages
 * the application's top-level states view (i.e., /states).
 *
 * @module routes.simulation.states
 */

angular.module('routes.simulation.states', [
  'stack',
  'routes.simulation.states.constants',
  'routes.simulation.states.SimulationStatesPayloadResolver',
  'routes.simulation.states.SimulationStatesController'
])
.config(
  [
    '$stateProvider',
    function ($stateProvider) {
      'use strict';

      $stateProvider
        .state('routes.simulation.states', {
          url: '/states/:stateId',
          templateUrl: 'routes/simulation/states/states.html',
          controller: 'SimulationStatesController',
          params: {
            stateId: { value: null, squash: true }
          },
          resolve: {
            constants: [
              'ConstantResolver',
              'STATES',
              function (ConstantResolver, STATES) {
                return new ConstantResolver(STATES);
              }
            ],
            statesPayload: [
              'SimulationStatesPayloadResolver',
              '$stateParams',
              'simulationPayload',
              function (SimulationStatesPayloadResolver, $stateParams, simulationPayload) {
                return new SimulationStatesPayloadResolver($stateParams, simulationPayload);
              }
            ]
          }
        }
      );
    }
  ]
);
